module.exports = __webpack_public_path__ + "img/69.b0939f26.jpg";